import React from 'react';
import ButtonToggleColumnExport
    from "@containers/export/containers/buildData/view/buttons/buttonToggleColumnExport/ButtonToggleColumnExport";
import {
    IExportMutateContext,
    IExportParamsContext
} from "@containers/export/containers/buildData/hooks/types/exportParams";
import {mapperColumnCbType} from "@ui/tableCustom/types/table";
import {IColumnItem} from "@ui/tableCustom/types/columns";
import SetOrderButton from "@ui/tableCustom/head/setOrderButton/SetOrderButton";


interface IProps<T> {
    exportParams: IExportParamsContext<T>,
    exportMutate: IExportMutateContext<T>,
    mapperColumnCb?: mapperColumnCbType<T>,
    order: keyof T | false,
    setOrder: (order: keyof T) => void
    direction: string,
    setDirection: (order: string) => void,
    column: IColumnItem<T>,

}

function TableHeadColumnBaseFeatures<T>({
                                            exportMutate,
                                            exportParams,
                                            column,

                                            direction, setDirection,
                                            order, setOrder,
                                        }: IProps<T>) {

    const {exportMode} = exportParams;

    return (
        <>
            {exportMode && !column.hideExportFeatures && column.id !== 'action' &&
                <ButtonToggleColumnExport
                    <T>
                    exportMutate={exportMutate}
                    exportParams={exportParams}
                    id={column.id}
                    exportGroupProps={column.exportGroupProps}
                />}

            {!column.hideSortFeatures && <SetOrderButton
                order={order}
                direction={direction}
                setDirection={setDirection}
                setOrder={setOrder}
                column={column}
            />}
        </>
    );
};

export default TableHeadColumnBaseFeatures;